




import { Component, Vue } from 'vue-property-decorator';
import router from '@/router';

@Component({
  beforeRouteLeave: (to, from, next) => {
    if (to.name && [ 'PaychecksNew', 'PaychecksEdit', 'Paychecks' ].includes(to.name)) {
      router.app.$sMessage.warning(router.app.$t('PopupBody.leavingAdvancedPaychecksMode'), {duration: 10000});
    }
    next();
  },
})
export default class AdvancedPaychecks extends Vue {}
